import { MockCard } from '../../components/mockups/MockUI'
import { MockTable } from '../../components/mockups/MockTable'
import { MockBadge } from '../../components/mockups/MockBadge'

export function RolesOverview() {
  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-lg font-semibold text-gray-900 dark:text-gray-100 mb-2">Обзор ролей</h2>
        <p className="text-sm text-gray-600 dark:text-gray-400">
          В системе 12 ролей. Семь основных: ADMIN, Генеральный директор, MANAGER, PROCUREMENT
          (Закупщик), РОП (руководитель отдела продаж), РОЗ (руководитель отдела закупок), Помощник.
          Пять ролей этапа 3 (с 23.09.2026): Бухгалтер, Логист, Руководитель склада, Приёмка и ОТК,
          Кладовщик — права им выдаются по мере запуска их разделов. Роль определяет, какие данные
          пользователь видит и какие действия может совершать.
        </p>
      </div>
      <MockTable
        caption="Сводка по ролям"
        columns={[{ header: 'Роль' }, { header: 'Что видит' }, { header: 'Что может делать' }]}
        rows={[
          [
            <MockBadge color="red">ADMIN</MockBadge>,
            'Всё в системе, кроме «Очереди квот» (раздел закрыт у ADMIN с 18.09.2026)',
            'Создавать пользователей, править курсы валют и наценки, импортировать каталог',
          ],
          [
            <MockBadge color="gray">Ген. директор</MockBadge>,
            'Всё в системе, как ADMIN',
            'Только просмотр — без права изменений; может писать свои комментарии',
          ],
          [
            <MockBadge color="blue">MANAGER</MockBadge>,
            'Свои заявки и клиентов; всех клиентов независимо от города',
            'Создавать заявки, формировать КП, закрывать сделки',
          ],
          [
            <MockBadge color="purple">PROCUREMENT</MockBadge>,
            'Очередь закупки по своим городам, свои квоты',
            'Создавать квоты, импортировать Excel-ответы, отмечать заявки завершёнными',
          ],
          [
            <MockBadge color="orange">РОП</MockBadge>,
            'Полноценный менеджер в рамках своих городов; пустые города = «всё»',
            'Всё, что менеджер: заявки, клиенты, КП. Подписывает «готово к КП»',
          ],
          [
            <MockBadge color="green">РОЗ</MockBadge>,
            'Заявки и квоты команды закупщиков по своим городам',
            'Всё, что закупщик, плюс агрегат по команде. Подписывает «готово к КП»',
          ],
          [
            <MockBadge color="yellow">Помощник</MockBadge>,
            'Заявки и клиентов прикреплённых к нему менеджеров',
            'Работает как менеджер в этих рамках: заявки, позиции, квоты, КП',
          ],
          [
            <MockBadge color="teal">Бухгалтер</MockBadge>,
            '«Курс валют» с историей и коэффициентами наценки, «Планирование», ленту новостей',
            'Править курсы валют и вносить факт продаж и АКБ (план — нет), публиковать новости',
          ],
          [
            <MockBadge color="teal">Логист</MockBadge>,
            '«Нетарифка», «Запросы брокеру», «Брокеры» — позиции без цен, карточку заявки не открывает',
            'Вносить ответ брокера и статусы нетарифки, комментировать позиции своей очереди, публиковать новости',
          ],
          [
            <MockBadge color="gray">Руководитель склада</MockBadge>,
            'Главную с лентой новостей',
            'Публиковать новости; разделы склада — на этапе 5',
          ],
          [
            <MockBadge color="gray">Приёмка и ОТК, Кладовщик</MockBadge>,
            'Главную с лентой новостей',
            'Только чтение; разделы склада — на этапе 5',
          ],
        ]}
      />
      <MockCard>
        <div className="text-sm text-gray-600 dark:text-gray-400">
          MANAGER — рядовой сотрудник отдела продаж. РОП — его руководитель, видит работу всей
          команды по городам. PROCUREMENT — рядовой закупщик, РОЗ — руководитель закупки.
          Генеральный директор и Помощник — «производные» роли: первый смотрит всё без права правок,
          второй работает от имени своих менеджеров.
        </div>
      </MockCard>
      <MockCard>
        <div className="text-sm text-gray-600 dark:text-gray-400 space-y-2">
          <div className="font-medium text-gray-800 dark:text-gray-200">Генеральный директор:</div>
          <ul className="list-disc list-inside space-y-1">
            <li>Видит все данные системы — заявки, клиентов, квоты, аналитику, планирование</li>
            <li>
              Любая попытка изменения отклоняется сервером — доступны только просмотр, свои
              комментарии, уведомления и обратная связь
            </li>
            <li>
              В «Очереди квот» может скрывать позиции у себя — кнопки «Скрыть у себя» / «Показать
              скрытые» (у других пользователей ничего не меняется)
            </li>
          </ul>
          <div className="font-medium text-gray-800 dark:text-gray-200 mt-3">Помощник:</div>
          <ul className="list-disc list-inside space-y-1">
            <li>
              Работает как менеджер, но только в рамках заявок и клиентов прикреплённых к нему
              менеджеров — создаёт и правит заявки, позиции, квоты, КП; архивирует, удаляет и
              восстанавливает заявки, меняет заказы до полной оплаты
            </li>
            <li>
              «Планирование» — только просмотр своих менеджеров; на главной у каждого менеджера —
              план и факт текущего месяца
            </li>
            <li>
              Прикрепление настраивает ADMIN на странице «Аккаунты»: у пользователя с ролью
              «Помощник» в колонке «Город / Менеджеры» — выпадающий список с чекбоксами (кандидаты —
              активные менеджеры и РОПы)
            </li>
            <li>
              Свой дашборд без KPI и выручки — карточки прикреплённых менеджеров со счётчиками и
              списки «выставить КП / просрочено / горящие»
            </li>
          </ul>
        </div>
      </MockCard>
    </div>
  )
}

export function RolesRopRos() {
  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-lg font-semibold text-gray-900 dark:text-gray-100 mb-2">
          РОП и РОЗ — особенности
        </h2>
        <p className="text-sm text-gray-600 dark:text-gray-400">
          Руководящие роли работают как обычные сотрудники + получают агрегат по команде. У обеих
          ролей — фильтр по городам, как у закупщика.
        </p>
      </div>
      <MockCard>
        <div className="text-sm text-gray-600 dark:text-gray-400 space-y-2">
          <div className="font-medium text-gray-800 dark:text-gray-200">
            РОП (руководитель отдела продаж):
          </div>
          <ul className="list-disc list-inside space-y-1">
            <li>Может создавать, редактировать и удалять заявки/клиентов в рамках своих городов</li>
            <li>Видит все клиенты и заявки команды (по городам менеджеров-владельцев)</li>
            <li>
              Фильтры в списках клиентов и заявок работают внутри его зоны — РОП не видит заявки
              менеджеров других городов
            </li>
            <li>
              Доступен раздел «Планирование» — план/факт и АКБ по менеджерам своей команды, рейтинг
              и график план/факт
            </li>
            <li>Подписывает «готово к КП» — переход заявки в статус «Готова к КП»</li>
            <li>Пустой список городов = доступ ко всему («админ по линии продаж»)</li>
          </ul>
          <div className="font-medium text-gray-800 dark:text-gray-200 mt-3">
            РОЗ (руководитель отдела закупок):
          </div>
          <ul className="list-disc list-inside space-y-1">
            <li>
              Полноценно работает с квотами как обычный закупщик — создаёт и правит свои квоты
            </li>
            <li>В списках видит агрегат по команде — квоты любого закупщика своих городов</li>
            <li>Статус позиции и заявки («закупщицкий статус») считается как агрегат команды</li>
            <li>
              Отличие от обычного закупщика: обычный закупщик видит только свои квоты и свой
              прогресс, РОЗ — командный X/Y по всем закупщикам своей зоны
            </li>
            <li>Тоже подписывает «готово к КП»</li>
          </ul>
        </div>
      </MockCard>
    </div>
  )
}

export function RolesCities() {
  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-lg font-semibold text-gray-900 dark:text-gray-100 mb-2">
          Города и видимость
        </h2>
        <p className="text-sm text-gray-600 dark:text-gray-400">
          Город пользователя — это инструмент маршрутизации заявок между командами. Раньше фильтр
          шёл по городу клиента, сейчас — по городу{' '}
          <span className="font-medium">менеджера-владельца заявки</span>. Менеджер сам свободно
          работает с клиентом из любого города.
        </p>
      </div>
      <MockTable
        caption="Кому какой город задаётся"
        columns={[{ header: 'Роль' }, { header: 'Назначение поля «Города»' }]}
        rows={[
          [<MockBadge color="red">ADMIN</MockBadge>, 'Не используется — видит всё'],
          [
            <MockBadge color="blue">MANAGER</MockBadge>,
            'Город менеджера — закупщики/РОП/РОЗ видят его заявки только если он в их городе',
          ],
          [
            <MockBadge color="purple">PROCUREMENT</MockBadge>,
            'Видит позиции заявок, чьи менеджеры в этих городах',
          ],
          [<MockBadge color="orange">РОП</MockBadge>, 'Видит заявки менеджеров своих городов'],
          [
            <MockBadge color="green">РОЗ</MockBadge>,
            'То же, что закупщик; агрегирует команду по городам',
          ],
        ]}
      />
      <MockCard>
        <div className="text-sm text-gray-600 dark:text-gray-400 space-y-2">
          <div className="font-medium text-gray-800 dark:text-gray-200">Как настроить:</div>
          <ol className="list-decimal list-inside space-y-1">
            <li>Открыть страницу «Аккаунты» (только ADMIN)</li>
            <li>Нажать «Редактировать» на нужном пользователе</li>
            <li>В дропдауне «Города» выбрать одну из опций: Все / Санкт-Петербург / Москва</li>
            <li>Сохранить — изменения применяются сразу, без перелогина</li>
          </ol>
          <p className="mt-2">
            Пустой список = доступ ко всем городам без ограничений. У менеджера с пустыми городами
            заявки видят все закупщики.
          </p>
        </div>
      </MockCard>
    </div>
  )
}
